import {SAVER_NAMESPACE, PALLET_NAMESPACE,PALLET_COMMITS,SAVER_DISPATCHS} from '@/store/contracts'

const saverPalletSyncPlugin = store => {
    const saveAction = {
      text: '保存',
      icon: 'circle-check-filled',
      execute: ()=>{
        store.dispatch(SAVER_NAMESPACE+'/'+SAVER_DISPATCHS.SUBMIT)
      }
    }
    // 当 store 初始化后调用
    store.watch(
      (state, getters) => {
        return getters[SAVER_NAMESPACE+'/isUnsaved']
      },
      (isUnsaved) => {
        
        if(isUnsaved){
          store.commit(PALLET_NAMESPACE+'/'+PALLET_COMMITS.ADD_TRAY,{
            key: SAVER_NAMESPACE,
            actions: saveAction
          })
        }else{
          store.commit(PALLET_NAMESPACE+'/'+PALLET_COMMITS.REMOVE_TRAY, SAVER_NAMESPACE)
        }
      },
      {immediate:true}
    )
  }

export default saverPalletSyncPlugin